/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';

import { connect } from 'react-redux';
import { Form, Row, Col, Spinner } from 'react-bootstrap';

import { LocationService } from 'shared/services';

import { image_thumbnail } from 'shared/images/images';
import store from 'features/store';
import { convertToMaintainData, disablePreviousState, favoriteLocationList, getMaintainData } from 'shared/settings/stateMaintain';

import './FavoriteLocation.scss';
import { logout } from 'shared/settings/auth';
import { isAuthorized } from 'shared/settings/auth';
import LocationCard from '../public/HOC/LocationCard';
import { HeartPlusIcon } from 'shared/assets/icons';
import MultiListPage from '../public/HOC/MultiListPagination';

/**


@Author Karthik

@param

@return html code for favorite locations list

**/

class FavoriteLocation extends Component {
    constructor(props) {
        super(props);

        this.scrollRef = createRef();


        this.state = {
            pageLoading: true,
            locationList: [],
            nextList: null,
            locationInProgress: {},
            favoriteLocations: [],
            noDataFound: false,

            /* To handle responsive */
            innerWidth: window.innerWidth,
            filterLoading: false,
            isVisible: false,
            pageClientWidth: 16,
            scrollTo: 0,
            updateAllFavoriteLocations:null
        }
    }

    componentDidMount() {
        this.getReqiuredData();
        window.addEventListener('resize', this.resizeHandle);
    }

    getReqiuredData = (append = false) => {
        const previousData = getMaintainData(favoriteLocationList);
        if (previousData && this.props.previousPath.component === "SaleListForLocation") {
            disablePreviousState();

            if (isAuthorized()) {
                this.getFavoriteLocation();
            }
            this.setState({
                ...previousData,
                pageLoading: false
            }, () => {
                this.scrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
                store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "locationList" } });
            });
        } else {
            const favoritePostData = {
                "sort": [{ "field": "id", "direction": "asc" }],
                "field": ["id", "locationid", "buyerid"],
                "page": this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 }
            };
            store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "locationList" } });
            LocationService.getFavoriteLocation(favoritePostData).then(favoriteLocationData => {
                const favoriteLocationDataTemp = favoriteLocationData.data.data;
                const onlyLocation = favoriteLocationDataTemp.map(x => x.locationid);
                const locationpostData = {
                    "sort": [{ "field": "title", "direction": "asc" }],
                    "filter": [{ "field": "id", "value": [onlyLocation], "op": "IN", "join": "AND" }],
                    "page": { 'size': onlyLocation.length + 1 }
                };
                LocationService.getLocationList(locationpostData).then(
                    locationList => {
                        const favoriteLocations = append ? this.state.favoriteLocations : [];
                        const previousLocationList = append ? this.state.locationList : [];
                        const temp = favoriteLocationData.data.page && favoriteLocationData.data.page.keyset && favoriteLocationData.data.page.keyset.next ? favoriteLocationData.data.page.keyset.next : null;
                        const allData = previousLocationList.concat(locationList.data.data)
                        this.setState({
                            locationList: allData,
                            pageLoading: false,
                            nextList: temp,
                            favoriteLocations: favoriteLocations.concat(favoriteLocationDataTemp),
                            loaderForMore: false,
                            noDataFound: allData.length === 0
                        });
                    }
                ).catch((error) => {
                    // TODO: Error message handle
                    this.setState({
                        noDataFound: true,
                        pageLoading: false,
                    });
                });
            }).catch(error => {
                // TODO: Error message handle
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(this.props.history, false);
                } else {
                    this.setState({
                        noDataFound: true,
                        pageLoading: false,
                    });
                }
            });

        }
    }


    navigate = (event, location) => {
        // let classList = [...event?.target?.classList];
        // const check = classList.length > 0 && (classList.includes('custom-control-label') || classList.includes('custom-control-input'));
        // if (!check) {
            const data = {
                locationList: this.state.locationList,
                nextList: this.state.nextList,
                loaderForMore: this.state.loaderForMore,
                isVisible: this.state.isVisible,
                pageClientWidth: this.state.pageClientWidth,
                scrollTo: this.state.scrollTo,
                locationInProgress: this.state.locationInProgress,
                favoriteLocations: this.state.favoriteLocations,
            };
            convertToMaintainData(favoriteLocationList, data)
            const favouriteLocationUrl = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(favouriteLocationUrl);
        // }
    }

    getMoreList = () => {
        this.setState({
            loaderForMore: true
        }, () => {
            this.getReqiuredData(true);
        });
    }

    getProfileImage = (location) => {
        const locationImage = {};
        if (location.imageurl) {
            const image = location.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    }


    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                scrollTo: event.target.scrollTop,
                pageClientWidth: this.scrollRef?.current?.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    resizeHandle = () => {
        this.setState({
            pageClientWidth: this.scrollRef?.current?.clientWidth
        });
    }

    favoriteLocation = (event, location) => {
        this.setState({
            locationInProgress: {
                ...this.state.locationInProgress,
                [location.id]: true
            }
        }, () => {
            if (event) {
                this.addFavoriteLocation(location);
            } else {
                this.removeFavoriteLocation(location);
            }
        });
    }

    isFavoriteLocation = (location) => {
        return this.state.favoriteLocations.findIndex(x => x.locationid === location.id) > -1;
    }


    addFavoriteLocation = (location) => {
        const postData = { "data": { "locationid": location.id } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.state.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }

    removeFavoriteLocation = (location) => {
        const favoriteLocations = this.state.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location.id);
        const postData = { "data": { "locationIds": [{ "id": location.id }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }

   
    getFavoriteLocation = (updateAll = false) => {
        this.setState({
            updateAllFavoriteLocations: updateAll
        }, () => {
            const postData = {
                "sort": [{ "field": "id", "direction": "asc" }],
                "field": ["id", "locationid", "buyerid"],
                "page": { "size": 999 }
            };
            if (isAuthorized()) {
            LocationService.getFavoriteLocation(postData).then(res => {
                const data = res.data.data;
                this.setState({
                    favoriteLocations: data,
                    updateAllFavoriteLocations: false
                });
            }).catch(error => {
                this.setState({
                    favoriteLocations: [],
                    updateAllFavoriteLocations: false
                });
            });
            }
        });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeHandle);
    }

    render() {
        return (
            <div className="favorite-locations-list-main" onScroll={this.handleScroll} ref={this.scrollRef}>
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> : <div className="locations-list h-100">
                            <div className={`list-section ${this.state.locationList.length === 0 ? 'h-100' : ''}`}>
                                <div className={`d-flex align-items-center justify-content-center ${this.state.locationList.length === 0 ? 'h-100' : ''}`}>
                                    <div className="favloc-large-screen-width">
                                        {
                                            this.state.locationList.length === 0 ?
                                                <div className="text-center h4 text-bold mt-3">
                                                    You don’t have any Favorite locations yet. Click on the “heart” buttons to save a location {HeartPlusIcon}
                                                </div> : null
                                        }
                                        <Row xs={1} sm={1} md={2} lg={3} className="mt-3 fav-loc-resp">
                                            {
                                                window.innerWidth <= 580 ? 
                                                <MultiListPage
                                                    list={this.state.locationList}
                                                    renderItem={(location, index) => {
                                                        return (
                                                            <div className="p-2" >
                                                                <LocationCard 
                                                                    locationData={location}
                                                                    isFav={this.isFavoriteLocation(location)}
                                                                    addFav={()=>{ this.favoriteLocation(!this.isFavoriteLocation(location), location)}}
                                                                    getProfileImage={this.getProfileImage(location)}
                                                                    navigate={(event)=>{this.navigate(event, location)}}
                                                                />
                                                            </div>
                                                        )
                                                    }}
                                                    count={this.state.locationList.length}
                                                    screensize={2}
                                                />
                                                : 
                                                this.state.locationList.map((location, index) =>
                                                    <Col key={`location_${index}`}>
                                                         <LocationCard
                                                            locationData={location}
                                                            isFav={this.isFavoriteLocation(location)}
                                                            addFav={()=>{ this.favoriteLocation(!this.isFavoriteLocation(location), location)}}
                                                            getProfileImage={this.getProfileImage(location)}
                                                            navigate={(event)=>{this.navigate(event, location)}}
                                                            />
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(FavoriteLocation);